<script lang="ts" generics="TValues">
    import Row from '$components/Form/Row.svelte';
    import type { Form } from '@jmvdevelop/svelte-form';
    import type { Fields } from '$components/MultiQuoteForm/MultiQuoteFormData';
    import Textarea from '$components/Form/Textarea.svelte';
    import PrettyChoiceMultiple from '$components/Form/PrettyChoiceMultiple.svelte';
    import PrettyChoice from '$components/Form/PrettyChoice.svelte';
    import Select from '$components/Form/Select.svelte';

    export let form: Form<TValues, string>;
    export let fields: Fields<TValues>;

    const businessStatusOptions = [
        `En cours de création`,
        `PME/TPE`,
        `Entreprise de taille intermédiaire`,
        `Grande entreprise`,
        `Association / ONG`,
        `Profession libérale`,
    ].map((v) => ({ label: v, value: v, key: v }));

    const servicesOptions = [
        `Tenue de comptabilité`,
        `Audit / Commissariat aux comptes`,
        `Conseil fiscal`,
        `Gestion de la paie`,
        `Création d’entreprise / Statuts`,
        `Déclarations fiscales et sociales`,
        `Reporting & analyse financière`,
        `Autres (à préciser)`,
    ].map((v) => ({ label: v, value: v, key: v }));

    const supportTypeOptions = [
        `Ponctuel (ex. audit, création d’entreprise, déclaration)`,
        `Régulier (gestion mensuelle, suivi comptable/fiscal)`,
        `Je ne sais pas encore`,
    ].map((v) => ({ label: v, value: v, key: v }));
</script>

<div class="flex flex-col gap-8 @container">
    <Row
        {form}
        field={fields.expertComptable.businessStatus}
        class=""
        let:field
        let:id
        label={`Quel est le statut de votre entreprise ?`}
    >
        <Select
            {form}
            {id}
            {field}
            required={false}
            showChevron
            options={businessStatusOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.expertComptable.services}
        class=""
        let:field
        let:id
        label={`Quels services recherchez-vous ?`}
        helpLabel="Maximum 4 choix"
    >
        <PrettyChoiceMultiple
            {form}
            {id}
            {field}
            max={4}
            defaultClass="grid grid-cols-1 @[350px]:grid-cols-2 gap-x-6 gap-y-1"
            choices={servicesOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.expertComptable.supportType}
        class=""
        let:field
        let:id
        label={`Souhaitez-vous un accompagnement ponctuel ou un suivi régulier ?`}
    >
        <PrettyChoice
            {form}
            {id}
            {field}
            defaultClass="grid grid-cols-1 gap-x-6 gap-y-1"
            choices={supportTypeOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.message}
        required
        label={'Votre demande'}
        helpLabel="Précisez votre besoin, soyez le plus précis dans votre demande de devis"
        let:field
    >
        <Textarea
            {form}
            {field}
            placeholder={`Précisez votre besoin, soyez le plus précis dans votre demande`}
            toText={(id) => id}
            fromText={(id) => id}
            class={''}
            rows={5}
        />
    </Row>
</div>
